import type { LanguageCode } from "../languages";
import type { LangsFormatMapValues, ValuesMapValues, Variables } from "./dynamicVariables.d";
import { currenciesMap, langsFormatMap, valuesMap } from "./dynamicVariables.config";
import { findValue, formatValue } from "./dynamicVariables.utils";

export const getDynamicVariable = (
  variable: Variables,
  language: LanguageCode = undefined,
  staticValue?: number | string
) => {
  const value = (findValue(valuesMap[variable], language) as Pick<ValuesMapValues, "value">)?.value || staticValue;

  const currency =
    currenciesMap[(findValue(valuesMap[variable], language) as Pick<ValuesMapValues, "currency">)?.currency] || "";

  const { format, separator } = findValue(langsFormatMap, language) as LangsFormatMapValues;

  return String(format).replace("<value>", formatValue(value, separator)).replace("<currency>", currency).trim();
};
